import { Booth, Meetingroom } from '../../../../../../../interfaces/interfaces';
import { fetchAndSetNetworks } from '../../../../../../../reduxToolkit/slices/commonSlice';
import MeetingRoom from '../../../../../../account/MeetingRoom';
import { TabContentWrapper } from './TabContentWrapper';
import { useSelector, useDispatch } from '../../../../../../../reduxToolkit/typedRedux';

const BoothNetworkingTab = ({ booth }: { booth: Booth }) => {
  const event = useSelector((state) => state.common.event);
  const dispatch = useDispatch();
  const networks = useSelector((state) => state.common.networks);

  const assignedNetworkIds = booth.networkingrooms.map((boothNetworks) => boothNetworks._id);

  function getAssignedNetworks() {
    return networks.filter((i) => assignedNetworkIds.includes(i._id));
  }

  return (
    <TabContentWrapper>
      <div className="flex flex-wrap w-full">
        {getAssignedNetworks().map((room) => (
          <MeetingRoom
            room={(room as unknown) as Meetingroom}
            refresh={async () => {
              dispatch(fetchAndSetNetworks(event!._id));
            }}
          />
        ))}
      </div>
    </TabContentWrapper>
  );
};
export default BoothNetworkingTab;
